import {defineRouting} from 'next-intl/routing';

export const routing = defineRouting({
  // 支持的语言列表
  locales: ['en', 'zh', 'ja', 'ko', 'es', 'fr', 'de', 'ar', 'th', 'pl', 'tr', 'cs', 'pt'],
  
  // 默认语言
  defaultLocale: 'en',
  
  // 语言前缀策略：as-needed 表示默认语言不显示前缀，其他语言显示前缀
  localePrefix: 'as-needed',
  
  // 禁用自动语言检测，避免与谷歌翻译冲突
  localeDetection: false
  
  // 移除pathnames配置，使用共享路径名（所有语言使用相同的路径）
  // 这样 /faq 对于英语，/zh/faq 对于中文
}); 